import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "recompose";
import Styled from "./Styled";
import { withQueryParser } from "components";
import video from "assets/video/night.mp4";
import video2 from "assets/video/small.mp4";
import Aside from "./aside";
import Nav from "./Nav";
import { Trans } from 'components';

const propTypes = {
  me: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
};

class Container extends React.Component {
  tokenName = `${this.props.me.id}_tutorial_videos`;
  state = {
    videos: [
      { url: video, id: 0, length: "0.20", title: "cosmos" },
      { url: video2, id: 1, length: "0.05", title: "lego robot" },
    ],
    visited: localStorage[this.tokenName] ? JSON.parse(localStorage[this.tokenName]) : [],
  };
  componentDidMount() {
    const { query } = this.props;
    this.saveAsVisited(query.video || 0);
  }
  componentDidUpdate(oldProps) {
    const { query } = this.props;
    if (query.video !== oldProps.query.video) {
      this.saveAsVisited(query.video || 0);
    }
  }
  saveAsVisited = id => {
    const { visited } = this.state;

    if (visited.includes(id)) {
      return;
    }
    const newVisited = [...visited, id];
    this.setState({ visited: newVisited });
    localStorage.setItem(this.tokenName, JSON.stringify(newVisited));
  };
  render() {
    const { videos, visited } = this.state;
    const { query } = this.props;
    const activeVideo = query.video || 0;
    return (
      <React.Fragment>
        <Nav />
        <Styled.Container>
          <Styled.VideoContainer>
            <Styled.Video autoPlay={true} controls={true} key={activeVideo}>
              <source src={videos[activeVideo].url} type="video/mp4" />
              <Trans>Ta przeglądarka nie wspiera odtwarzacza wideo.</Trans>
            </Styled.Video>
          </Styled.VideoContainer>
        </Styled.Container>
        <Aside videos={videos} active={activeVideo} visited={visited} />
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  me: state.auth.user,
});

Container.propTypes = propTypes;
const enhance = compose(withQueryParser, connect(mapState));
export default enhance(Container);



// WEBPACK FOOTER //
// ./src/pages/tutorial/Container.jsx